import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowLeft } = FiIcons;

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Link to="/" className="inline-flex items-center text-blue-600 hover:text-blue-700 mb-8 transition-colors">
            <SafeIcon icon={FiArrowLeft} className="w-4 h-4 mr-2" />
            Volver al inicio
          </Link>

          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-8">Términos de Servicio</h1>
            
            <div className="space-y-6 text-gray-700">
              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Titularidad</h2>
                <p>
                  Estos Términos de Servicio regulan el uso de la plataforma NormaAlerta, propiedad de <strong>ÁNGEL SEISDEDOS GAVIRA</strong> (en adelante, "el Titular"), con NIF 45.660.354-H y domicilio en Calle Miguel Vázquez Delgado, 3ºC, San José de la Rinconada, Sevilla.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Objeto del Servicio</h2>
                <p className="mb-3">
                  NormaAlerta es una herramienta de monitorización y alerta de cambios normativos publicados en el Boletín Oficial del Estado (BOE).
                </p>
                <p>
                  <strong>Importante:</strong> La información proporcionada tiene carácter meramente informativo y de alerta temprana. No constituye asesoramiento jurídico ni sustituye la consulta de las fuentes oficiales.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-3">3. Registro y Cuentas</h2>
                <p className="mb-3">
                  Para utilizar el servicio es necesario registrarse. El usuario garantiza que los datos aportados son veraces y se hace responsable de la custodia de su contraseña.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Planes y Pagos</h2>
                <div className="space-y-3">
                  <p>NormaAlerta ofrece modalidades gratuitas y de pago (Plan Pro).</p>
                  <ul className="list-disc pl-6 space-y-1">
                    <li>Los precios están expresados en Euros e incluyen los impuestos aplicables.</li>
                    <li>La suscripción se renueva automáticamente salvo cancelación.</li>
                    <li>No se realizan reembolsos por periodos parciales no disfrutados.</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-3">5. Propiedad Intelectual</h2>
                <p>
                  Todos los contenidos de la web (diseño, software, textos de análisis) son propiedad exclusiva del Titular. Los textos legales del BOE son de dominio público.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Legislación y Fuero</h2>
                <p>
                  Estos términos se rigen por la ley española. Para cualquier controversia, ambas partes se someten a los Juzgados y Tribunales de Sevilla, renunciando a cualquier otro fuero que pudiera corresponderles.
                </p>
              </section>

              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mt-8">
                <p className="text-sm text-blue-800">
                  <strong>Última actualización:</strong> Enero 2026
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default TermsOfService;